if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
    }

    disconnectedCallback() {
      this.pauseAllVideos();
      if (this._onBlockSelect) {
        document.removeEventListener("shopify:block:select", this._onBlockSelect);
        this._onBlockSelect = null;
      }
      if (this.slider) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        navigation: this.showArrows
          ? {
              nextEl: this.querySelector(".m-slider-controls__button-next"),
              prevEl: this.querySelector(".m-slider-controls__button-prev"),
            }
          : false,
        pagination: this.showDots
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
              bulletClass: "m-dot",
              bulletActiveClass: "m-dot--active",
            }
          : false,
        breakpoints: {
          992: {
            threshold: 2,
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (Shopify.designMode) {
        this._onBlockSelect = (e) => this.onBlockSelect(e);
        document.addEventListener("shopify:block:select", this._onBlockSelect);
      }
    }

    loadDeferredVideo(video) {
      if (!video) return Promise.resolve();
      if (video.dataset.loaded === "true") return Promise.resolve();

      const sources = video.querySelectorAll("source[data-src]");
      sources.forEach((source) => {
        const src = source.getAttribute("data-src");
        if (src && !source.getAttribute("src")) {
          source.setAttribute("src", src);
        }
      });

      video.load();
      video.dataset.loaded = "true";
      video.classList.add("is-loaded");

      return new Promise((resolve) => {
        if (video.readyState >= 2) {
          resolve();
          return;
        }

        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          video.removeEventListener("canplay", finish);
          video.removeEventListener("loadeddata", finish);
          resolve();
        };

        video.addEventListener("canplay", finish);
        video.addEventListener("loadeddata", finish);
        setTimeout(finish, 2500);
      });
    }

    pauseAllVideos(exceptVideo = null) {
      this.querySelectorAll("video").forEach((video) => {
        if (exceptVideo && video === exceptVideo) return;
        video.pause();
      });
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const activeSlide = slides[activeIndex];
      const slideType = activeSlide && activeSlide.dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);

      if (slideType === "video_slide") {
        const video = activeSlide && activeSlide.querySelector("video[data-deferred-video], video");

        if (video) {
          this.pauseAllVideos(video);
          this.loadDeferredVideo(video).then(() => {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise
                .then(() => {
                  this.lastVideo = video;
                  const poster = activeSlide.querySelector(".m-slide__video-poster");
                  if (poster) poster.classList.add("is-hidden");
                })
                .catch(() => {
                  /* Autoplay may be blocked; poster remains visible */
                });
            }
          });
        }
      } else {
        this.pauseAllVideos();
        this.lastVideo = null;
        this.querySelectorAll(".m-slide__video-poster.is-hidden").forEach((poster) => {
          poster.classList.remove("is-hidden");
        });
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
